import "./OurFleetAboutUsContact.module.css";
import Header from "@/reusable_sections/Header";
import PremierFleetPreview from "./sections/PremierFleetPreview";
import RootedInNature from "./sections/RootedInNature";
import BookYourPickup from "./sections/BookYourPickup";
import Footer from "@/reusable_sections/Footer";
export default function OurFleetAboutUsContactPage() {
  return <div>
      <Header />
      <PremierFleetPreview />
      <RootedInNature />
      <BookYourPickup />
      <Footer />
    </div>;
}